import { ElementType, lazy } from "react";
import Reports from "../pages/admin/Reports";
import { Role } from "../types/common.type";
import Statement from "../pages/admin/Statement/Statement";
import Dashboard from "../pages/admin/Dashboard/Dashboard";
import DealerList from "../pages/admin/DealerList/DealerList";
import TraderList from "../pages/admin/TraderList/TraderList";
import Reconcile from "../pages/admin/Reconcile/Reconcile";
import ReconcileDetails from "../pages/admin/Reconcile/ReconcileDetails";
const NotFound = lazy(() => import("../pages/NotFound"));
const AdminLogin = lazy(() => import("../pages/admin/Login"));

export interface RouteType {
  path: string;
  element: ElementType;
  roles: Role[];
  name?: string;
}

// auth routers
export const sidebarRouters: RouteType[] = [
  {
    path: "/admin/dashboard",
    element: Dashboard,
    roles: ["admin"],
  },
  {
    path: "/admin/statement",
    element: Statement,
    roles: ["admin"],
  },
  {
    path: "/admin/dealer-list",
    element: DealerList,
    roles: ["admin"],
  },
  {
    path: "/admin/trader-list",
    element: TraderList,
    roles: ["admin"],
  },
  {
    path: "/admin/reconcile",
    element: Reconcile,
    roles: ["admin"],
  },
  {
    path: "/admin/reconcile/reconcile-details/:id",
    element: ReconcileDetails,
    roles: ["admin"],
  },
];

// public routers
export const publicRouters: Omit<RouteType, "roles">[] = [
  {
    path: "/admin/login",
    element: AdminLogin,
  },
  {
    path: "*",
    element: NotFound,
  },
];
